import { CurrencyValue, HugValue, NumberValue, PercentageValue, HashedNumberValue, OverlapBarValue, DateValue, RateChangeValue, BoxedValue, BarWithValue, DottedValue, EvolutionArrow, SegmentedBar, ImageElement, DottedPositionBar, BarWithDifferenceFromMaxMarked, RangeBar, DotElement, TextValue, ValueElement, MarketplaceValue, ProductValue, BrandParentValue } from "@/components/tableElements";
import FlexRow from "@/components/FlexRow.vue";
import { mapState } from "vuex";
import EvolutionValue from "@/components/tableElements/EvolutionValue.vue";
import SlotWithEvolutionValue from "@/components/tableElements/SlotWithEvolutionValue.vue";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import LayerBars from "@/components/tableElements/LayerBars.vue";
import VariableStyledBar from "@/components/tableElements/VariableStyledBar.vue";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
export default {
  name: "ProductTableTotal",
  mixins: [LiteTableMixin],
  props: {
    fields: {
      type: Array,
      default: () => []
    },
    total: {
      type: Object,
      default: () => ({})
    },
    currencyConfig: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    evolutionType: {
      type: String
    }
  },
  data() {
    return {
      evolCategory: {
        prev_period: "_vs_previous_period",
        same_period_ly: "_vs_previous_year"
      }
    };
  },
  components: {
    CurrencyValue,
    HugValue,
    NumberValue,
    PercentageValue,
    FlexRow,
    EvolutionValue,
    SlotWithEvolutionValue,
    HashedNumberValue,
    LayerBars,
    VariableStyledBar,
    OverlapBarValue,
    DateValue,
    RateChangeValue,
    BoxedValue,
    BarWithValue,
    DottedValue,
    EvolutionArrow,
    SegmentedBar,
    ImageElement,
    DottedPositionBar,
    BarWithDifferenceFromMaxMarked,
    RangeBar,
    DotElement,
    TextValue,
    ValueElement,
    MarketplaceValue,
    ProductValue,
    BrandParentValue,
    WrapWithPopover
  },
  computed: {
    ...mapState({
      periodCategory: state => state.search_funnel.periodCategory,
      groupBy: state => state.search_funnel.product_table.group_by_text,
      products: state => state.search_funnel.products
    })
  },
  methods: {
    isTotalColumn(field) {
      return ["category", "seller_name", "sales_channel", "search_query", "search_query_type", "product_name"].some(key => field.key == key);
    },
    getJustify(field) {
      return ["brand_ctr", "conversion_rate"].includes(field.key) ? "right" : "left";
    }
  }
};